import React from 'react'
import {View} from 'react-native'

const BottomListSpacer: React.FC = ({children}) => {
  return <View style={{height: 90}}></View>
}

export default BottomListSpacer
